// src/admin/views/PrizeAdminView.js
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import '../../styles/admin.css'
import ConfirmationModal from '../components/ConfirmationModal'
import PageHeader from '../components/PageHeader'
import { useAdminStore } from '../store/AdminStore'

function PrizeAdminView({
  prizeData,
  handleChange,
  handleSubmit,
  roundList,
  eventList,
  eventId,
  handleEventChange,
  handleDelete,
}) {
  const navigate = useNavigate()
  const orgName = useAdminStore((state) => state.orgName)
  const [showConfirmation, setShowConfirmation] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const prizeOptions = [
    { key: 0, value: 'Low Net' },
    { key: 1, value: 'Pinshot' },
    { key: 2, value: 'League Champ' },
    { key: 3, value: 'Skin' },
    { key: 4, value: 'Other' },
  ]

  return (
    <>
      <PageHeader pageName={'Prize Info'} backTo="/admin/prizes" />
      {orgName && (
        <div style={{ textAlign: 'center', fontWeight: 'bold', margin: '10px 0' }}>
          {orgName}
        </div>
      )}
      <div className="admin-card-container">
        <div className="admin-card">
          <form onSubmit={handleSubmit}>
            <div className="admin-input-group">
              <label htmlFor="eventId" className="admin-label">
                Event
              </label>
              <select
                name="eventId"
                id="eventId"
                className="admin-input"
                value={eventId || ''}
                onChange={handleEventChange}
                required
                disabled={!!prizeData?.prizeId}
              >
                <option value="">Select an Event</option>
                {eventList &&
                  eventList.map((event) => (
                    <option key={event.eventId} value={event.eventId}>
                      {moment(event.eventDate).format('YYYY-MM-DD')} -{' '}
                      {event.courseName} {event.rainout ? ' (RAINOUT)' : ''}
                    </option>
                  ))}
              </select>
            </div>

            <div className="admin-input-group">
              <label htmlFor="roundId" className="admin-label">
                Golfer
              </label>
              <select
                name="roundId"
                id="roundId"
                className="admin-input"
                value={prizeData.roundId}
                onChange={handleChange}
                required
              >
                <option value="">Select a Golfer</option>
                {roundList.map((round) => (
                  <option key={round.roundId} value={round.roundId}>
                    {round.golferName}
                  </option>
                ))}
              </select>
            </div>

            <div className="admin-input-group">
              <label htmlFor="prizeType" className="admin-label">
                Prize Type
              </label>
              <select
                name="prizeType"
                id="prizeType"
                className="admin-input"
                value={prizeData.prizeType}
                onChange={handleChange}
                required
              >
                {prizeOptions.map((option) => (
                  <option key={option.key} value={option.key}>
                    {option.value}
                  </option>
                ))}
              </select>
            </div>

            <div className="admin-input-group">
              <label htmlFor="prizeMoney" className="admin-label">
                Prize Money
              </label>
              <input
                type="number"
                id="prizeMoney"
                name="prizeMoney"
                className="admin-input"
                value={prizeData.prizeMoney}
                onChange={handleChange}
                required
                placeholder="0.00"
              />
            </div>

            <div className="admin-button-group">
              {prizeData?.prizeId && (
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setShowConfirmation(true)}
                  style={{ marginRight: 'auto' }}
                >
                  Delete
                </button>
              )}
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => navigate('/admin/prizes')}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Save Prize
              </button>
            </div>
          </form>
        </div>

        <ConfirmationModal
          questionText="Are you sure you want to delete this prize? Type DELETE to confirm."
          showConfirmation={showConfirmation}
          setShowConfirmation={setShowConfirmation}
          onConfirm={handleDelete}
        />
      </div>
    </>
  )
}

export default PrizeAdminView
